






























































































































import moment from "moment";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import AsesmenRisikoJatuh from "@/services/AsesmenRisikoJatuh";
import { appModule } from "@/store/modules/app";
import storeRefAsesmen from "@/store/modules/new/ReferensiAsesmen";
import { userModule } from "@/store/modules/user";

@Component
export default class AsesmenRisikoJatuhInput extends Vue {
	@Prop() register!: string;
	@Prop() rm!: string;
	@Prop() value: any;
	@Prop() readonly assignedId;
	@Prop({ default: "normal" }) mode: "normal" | "attach";
	@Prop({ default: false }) saveInput: boolean;
	@Prop({ default: [] }) metodeDisabled: string[];

	get isAttachedMode() {
		return this.mode === "attach";
	}

	selectProps = { openOnHover: true, offsetY: true };

	tab = "tab-mfs";
	risjat: {
		id: number;
		metode: string;
		skor: number;
		question: any;
	} = null;
	metode = "mfs";
	saving = false;
	risiko = 0;
	examinedAt: string | Date = new Date();
	risjatList = [];

	tug = null;
	skriningSecurity = null;
	hdVal = {};
	mfsVal = {};

	categVal = {
		mfs: {},
		hd: {},
	};

	timePickerProps = { format: "24hr", scrollable: true };
	datePickerProps = { locale: "id", max: moment().format("YYYY-MM-DD") };

	get categoryMFS() {
		return storeRefAsesmen.fallriskMFS;
	}

	get categoryHD() {
		return storeRefAsesmen.fallriskHumDum;
	}

	get metodeInput() {
		return this[`category${this.metode.toUpperCase()}`] ?? null;
	}

	get metodeOptions() {
		return [
			{
				id: "mfs",
				title: "Morse Fall Scale",
				note: "Untuk Dewasa dan anak > 3th",
			},
			{
				id: "hd",
				title: "Humpty Dumpty",
				note: "Untuk anak 0-18 th",
			},
			{
				id: "tug",
				title: "Time Up and Go",
				note: "Untuk pelayanan rawat jalan",
			},
		];
	}

	get selectedMetodeNote() {
		return this.metodeOptions.find((it) => it.id === this.metode)?.note ?? "";
	}

	get totalScore() {
		const cVal = this.categVal[this.metode]
			? Object.entries(this.categVal[this.metode])
			: [];

		if (this.metode == "tug") {
			return this.tug;
		}

		return this.metode &&
			cVal.length === this.metodeInput?.length &&
			cVal.every((it) => it[1] !== null)
			? cVal.map((i) => i[1]["scoring"]).reduce((a, b) => a + b, 0)
			: null;
	}

	get kategoriRisiko() {
		if (this.metode === "tug") {
			return this.tug !== null
				? this.tug == 1
					? "Berisiko"
					: "Tidak berisiko"
				: "-";
		}
		return (
			this[
				`inter${this.metode.charAt(0).toUpperCase() + this.metode.slice(1)}`
			] ?? "-"
		);
	}

	get totalMfs() {
		// return this.mfs.map(i => i.val).reduce((a, b) => a + b, 0);
		return Object.entries(this.mfsVal).length > 0
			? Object.entries(this.mfsVal)
					.map((i) => i[1]["scoring"])
					.reduce((a, b) => a + b, 0)
			: 0;
	}

	get interMfs() {
		return this.parseMfsRisiko(this.totalScore);
	}

	parseMfsRisiko(skor) {
		this.risiko = 0;

		if (skor === null || skor === undefined) {
			return "";
		} else if (skor < 25) {
			return "Tidak Berisiko";
		} else if (skor < 51) {
			this.risiko = 1;
			return "Rendah";
		} else if (skor >= 51) {
			this.risiko = 1;
			return "Tinggi";
		}

		this.risiko = 0;
		return "";
	}

	parseMetodeText(str) {
		if (str === "mfs") {
			return "Morse Fall Score";
		}

		if (str === "hd") {
			return "Humpty Dumpty";
		}

		if (str === "tug") {
			return "Time Up and Go";
		}

		return "";
	}

	get totalHd() {
		// return this.hd.map(i => i.val).reduce((a, b) => a + b, 0);
		return Object.entries(this.hdVal).length > 0
			? Object.entries(this.hdVal)
					.map((i) => i[1]["scoring"])
					.reduce((a, b) => a + b, 0)
			: 0;
	}

	get interHd() {
		return this.parseHdRisiko(this.totalScore);
	}

	parseHdRisiko(skor) {
		if (skor > 0 && skor < 12) {
			this.risiko = 1;
			return "Rendah";
		} else if (skor >= 12) {
			this.risiko = 1;
			return "Tinggi";
		}

		this.risiko = 0;
		return "";
	}

	parseTugRisiko(skor) {
		this.risiko = skor >= 1 ? 1 : 0;
		return skor >= 1 ? "Tinggi" : "Tidak berisiko";
	}

	@Watch("metode")
	changedMetode(val) {
		// this.tab = `tab-${val}`;
		if (val) {
			this.createNewMfs();
			this.categVal[val] = {};

			console.log("metode", val);
		}
	}

	// @Watch('categVal')

	createNewMfs() {
		this.risjat = null;
		this.categVal = {
			mfs: {},
			hd: {},
		};
		this.tug = null;
		this.skriningSecurity = null;
		this.examinedAt = new Date();
	}

	clearForm() {
		this.metode = "mfs";
		this.createNewMfs();
	}

	parseRisiko(item) {
		if (item.metode == "mfs") {
			return this.parseMfsRisiko(item.skor);
		}

		if (item.metode == "hd") {
			return this.parseHdRisiko(item.skor);
		}

		if (item.metode == "tug") {
			return this.parseTugRisiko(item.skor);
		}

		return "";
	}

	get sessLogin() {
		return userModule.user;
	}

	get params() {
		let question = null;

		if (this.metode !== "tug" && this.categVal[this.metode]) {
			question = Object.entries(this.categVal[this.metode]).map((i) => {
				return {
					ref_group_id: parseInt(i[0]),
					ref_id: i[1]["id"],
					skor: i[1]["scoring"],
				};
			});
		}

		return {
			register_id: this.register,
			pasien_rm: this.rm,
			unit_id: this.sessLogin.unit_id,
			risiko: this.risiko,
			skrining_security: this.metode === "tug" ? this.skriningSecurity : null,
			metode: this.metode,
			skor: this.totalScore,
			question: question,
			waktu_periksa: moment(this.examinedAt).format("YYYY-MM-DD HH:mm:ss"),
		};
	}

	async save() {
		if (!this.saving) {
			if (this.params.question) {
				const unfilled = this.params.question.filter((it) => it.val === null);

				if (unfilled.length > 0) {
					alert(
						`Isian ${unfilled.map((it) => it.title).join(", ")} harus diisi!`,
					);

					return false;
				}
			}

			this.saving = true;

			const SaveRisjat = this.risjat?.id
				? AsesmenRisikoJatuh.update(this.risjat.id, this.params)
				: AsesmenRisikoJatuh.create(this.params);

			const rtn = await SaveRisjat.then((resp) => {
				if (resp.status) {
					appModule.NoticeDelay("Berhasil menyimpan asesmen risiko jatuh");

					this.clearForm();
					// this.getByRegister();
					this.$emit("saved");

					return resp.data;
				}
			}).finally(() => {
				this.saving = false;
			});

			return rtn;
		}
	}

	@Watch("value")
	changedValue(val, oldVal = null) {
		if (val && val !== oldVal) {
			this.metode = val.metode;
			this.$nextTick(() => {
				// to make it deep copy immutable array or object use json.parse and json.stringify
				if (this.metode !== "tug") {
					const data: Array<any> = JSON.parse(JSON.stringify(val.question));
					const itm = {};
					data.forEach((it) => {
						if (it.ref_group_id) {
							itm[it.ref_group_id] = this[
								`category${this.metode.toUpperCase()}`
							]
								.find((cat) => cat.id == it.ref_group_id)
								?.val.find((val) => val.id == it.ref_id);
						}
					});
					this[`${this.metode}Val`] = itm;
					this.categVal[this.metode] = itm;
				} else {
					this.tug = val.skor;
					this.skriningSecurity = val.skrining_security ?? null;
				}
				this.risjat = JSON.parse(JSON.stringify(val));
				this.examinedAt = new Date(val.waktu_periksa);
			});
		} else if (!val) {
			this.clearForm();
		}
	}
}
